import { motion } from 'framer-motion';
import { Container } from '@/components/ui/container';
import { services } from '@/lib/services';

export default function LandingServices() {
	return (
		<Container>
			<div className="text-center mb-12">
				<h2 className="text-3xl md:text-4xl font-bold mb-4 font-space-grotesk">
					What Every Smart Tech Solution Is Built On
				</h2>
				<p className="text-muted-foreground text-lg max-w-3xl mx-auto">
					With over a decade leading digital projects for both major enterprises and local small
					businesses, I&apos;ve seen that great technology always rests on the same four pillars.
					Whether you&apos;re starting from scratch or optimizing what you already have, these
					principles guide every service I offer to help your local business thrive in the digital
					age.
				</p>
			</div>
			<div className="grid grid-cols-1 md:grid-cols-4 gap-12">
				{services.map((service, index) => (
					<motion.div
						key={service.title}
						initial={{ scale: 0.98, y: 5 }}
						animate={{ scale: 1, y: 0 }}
						transition={{
							duration: 0.2,
							delay: index * 0.05,
							ease: 'easeOut',
						}}
						whileHover={{
							y: -8,
							scale: 1.02,
							transition: { duration: 0.2 },
						}}
						className="space-card p-4 sm:p-5 rounded-xl flex flex-col min-h-[380px] relative group hover:shadow-[0_0_30px_rgba(255,255,255,0.1)] transition-all duration-300"
					>
						<div className="absolute inset-0 rounded-xl bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
						<div
							className={`w-12 h-12 sm:w-14 sm:h-14 rounded-full mb-4 sm:mb-6 flex items-center justify-center bg-primary/10 mx-auto  group-hover:scale-110 transition-transform duration-300`}
						>
							<service.icon className="w-6 h-6 sm:w-7 sm:h-7 text-primary" />
						</div>
						<h3 className="text-xl sm:text-2xl font-bold mb-3 font-space-grotesk break-words text-center">
							{service.title}
						</h3>
						<p className="text-muted-foreground text-base sm:text-lg mb-6 flex-grow text-center">
							{service.description}
						</p>
						{/* <Button variant="ghost" className="group w-fit">
							Learn More
							<ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
						</Button> */}
					</motion.div>
				))}
			</div>
		</Container>
	);
}
